import { Map } from "immutable";
import * as actionTypes from "~/store/action_types";

const projectOpenTasks = (state = new Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROJECTS_FOR_SCREEN_SUCCESS:
      if (action.response.result.length > 0) {
        return state.merge(
          action.response.result.reduce((acc, id) => {
            return {
              ...acc,
              [id]: action.response.entities.projects[id].count_open_tasks,
            };
          }, {})
        );
      }
      return state;
    case actionTypes.FETCH_PROJECT_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { count_open_tasks = 0, single = 0 } = result;

      return state.set(`${single}`, count_open_tasks);
    }
    case actionTypes.ADD_TASK_FROM_CONVERSATION_SUCCESS:
    case actionTypes.ADD_TASK_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: taskId = 0 } = result;

      const { tasks = {} } = entities;
      const task = tasks[taskId] ?? {};
      const { project_id: projectId } = task;

      if (projectId) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) + 1);
      }

      return state;
    }
    case actionTypes.BATCH_ADD_TASKS_SUCCESS: {
      const { response = {}, projectId = 0 } = action;
      const { result = [] } = response;

      if (projectId && result.length > 0) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) + result.length);
      }

      return state;
    }
    case actionTypes.MOVE_TASK_TO_PROJECT_SUCCESS: {
      const { response = {}, projectId = 0, newProjectId = 0, copy = false } = action;
      const { entities = {}, result = {} } = response;
      const { tasks = {} } = entities;
      const { single: taskId = 0 } = result;

      const task = tasks[taskId] ?? {};

      if (task && !task.is_completed && projectId !== newProjectId) {
        state = state.set(`${newProjectId}`, state.get(`${newProjectId}`) + 1);
        if (!copy) {
          state = state.set(`${projectId}`, state.get(`${projectId}`) - 1);
        }
      }

      return state;
    }
    case actionTypes.COMPLETE_TASK_SUCCESS:
    case actionTypes.MOVE_TASK_TO_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: taskId = 0 } = result;

      const { tasks = {} } = entities;
      const task = tasks[taskId] ?? {};
      const { project_id: projectId, is_completed: isCompleted } = task;

      if (!isCompleted && projectId) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) - 1);
      }

      return state;
    }
    case actionTypes.OPEN_TASK_SUCCESS:
    case actionTypes.RESTORE_TASK_FROM_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: taskId = 0 } = result;

      const { tasks = {} } = entities;
      const task = tasks[taskId] ?? {};
      const { project_id: projectId, is_completed: isCompleted } = task;

      if (!isCompleted && projectId) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) + 1);
      }

      return state;
    }
    default:
      return state;
  }
};

export default projectOpenTasks;
